import React, { memo, useMemo } from 'react'
import { Modal } from '@mui/material'
import tw from 'twin.macro'
import { ModalHeader } from 'src/components/shared/ModalHeader'
import { AddSingleMCPaymentForm } from './add-single-payment-form/AddSingleMCPaymentForm'

interface Props {
  isOpen?: boolean
  onClose: () => void
  onSubmit: () => void
}

const AddSingleMCPaymentModalComponent = ({ isOpen, onClose, onSubmit }: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`flex justify-center items-center backdrop-blur`}
    >
      <div
        data-testid="payments-mc-main-add-single-payment-modal"
        css={tw`bg-[#F6F6F6] rounded-lg w-[360px] overflow-hidden`}
      >
        <ModalHeader
          className={tw`bg-white`}
          title="Add single settlement"
          onClose={onClose}
          closeButtonDataTestId="payments-mc-main-add-single-payment-modal-close-btn"
        />
        <AddSingleMCPaymentForm onSuccess={onSubmit} />
      </div>
    </Modal>
  )
}

export const AddSingleMCPaymentModal = memo(AddSingleMCPaymentModalComponent)
